module.exports = __webpack_public_path__ + "static/544600984.f350a5f2.jpg";